import { PermissionRequest } from "@p0security/shared/types/permission";
import React from "react";

import { useSessionHistory } from "../hooks/useSessionHistory";
import { SessionTable } from "./SessionTable";

export const SessionHistoryButton: React.FC<{
  requestId: string;
  requestType: PermissionRequest["type"];
}> = ({ requestId, requestType }) => {
  const session = useSessionHistory(requestId);
  return <SessionTable {...session} requestType={requestType} />;
};
